(function(){

/*
// ページ内リンク
const smoothScrollTrigger = document.querySelectorAll('a[href^="#"]');
for (let i = 0; i < smoothScrollTrigger.length; i++){
  smoothScrollTrigger[i].addEventListener('click', (e) => {
    e.preventDefault();
    let href = smoothScrollTrigger[i].getAttribute('href');
    let targetElement = document.getElementById(href.replace('#', ''));
    if(targetElement){
      const rect = targetElement.getBoundingClientRect().top;
      const offset = window.pageYOffset;
      let gap = 0;
      let windowSize = window.innerWidth;
      if (windowSize > 767) {
        gap = document.querySelector('header.site-header').clientHeight;
      } else {
        gap = document.querySelector('.mobile-nav-bar-wrapper').clientHeight;
      }
      const target = rect + offset - gap;
      window.scrollTo({
        top: target,
        behavior: 'smooth',
      });
    }
  });
}
*/
// リンク「#」移動削除
const smoothScrollTrigger = document.querySelectorAll('a[href^="#"]');
for (let i = 0; i < smoothScrollTrigger.length; i++){
  smoothScrollTrigger[i].addEventListener('click', (e) => {
    let href = smoothScrollTrigger[i].getAttribute('href');
    let targetElement = document.getElementById(href.replace('#', ''));
    if(!targetElement){
      e.preventDefault();
    }
  });
}

// 新規会員登録 生年月日
if (document.URL.match(/register/)) {
  let time = new Date();
  let year = time.getFullYear();

  for (let i = 1900; i <= year; ++i) {
    if(i == 1990){
      createOptionElements(i, 'year', true);
    } else {
      createOptionElements(i, 'year', false);
    }
  }

  for (let i = 1; i <= 12; ++i) {
    createOptionElements(i, 'month', false);
  }

  for (var i = 1; i <= 31; i++) {
    createOptionElements(i,'day', false);
  }
}
function createOptionElements(num, parentId, isSelected){
  let doc = document.createElement('option');
  doc.value = doc.innerHTML = num;
  if(isSelected){
    document.getElementById(parentId).appendChild(doc).selected=true;
  } else {
    document.getElementById(parentId).appendChild(doc);
  }
}

})();

// 商品詳細アコーディオン
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.title').forEach(title => {
      title.addEventListener('click', () => {
          const findElm = title.nextElementSibling;
          if (findElm.style.height && findElm.style.height !== '0px') {
              findElm.style.height = '0px';
              findElm.style.opacity = '0';
              findElm.style.visibility = 'hidden';
              title.classList.remove('close');
          } else {
              findElm.style.height = `${findElm.scrollHeight}px`;
              findElm.style.opacity = '1';
              findElm.style.visibility = 'visible';
              title.classList.add('close');
          }
      });
  });
});